module.exports = __webpack_public_path__ + "static/media/tarra-h2h-picturemark-d.efa281fd.svg";